import { Button, Label, TextAreaInput, Unform } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext } from 'react';
import { Flex, Box, Stack } from '@chakra-ui/react';
import { SubmitHandler } from '@unform/core';
import { MessageInfo } from 'components/MessageInfo';
import { checkPermission } from 'utils/authentication';

import { evaluationCtx } from '../../index';
import Evaluation from 'models/Forms/Evaluation';

interface IProps extends BodyProps {}
interface ItemProps {
  heading: String;
  text: String;
}

const text1 =
  'Treinamento adequado de pessoal, manter os devidos registros de tratamento de dados, previsão de políticas institucionais sobre tratamento de dados, etc';

const TechnicalAspectsComponent: React.FC<IProps> = ({
  index,
  functionCallback,
  submit,
  completed,
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const ctx = useContext(evaluationCtx);
  const MessageInfoItems: ItemProps[] = [
    {
      heading: 'Exemplos para medidas de segurança administrativa: ',
      text: text1,
    },
  ];

  const handleSubmit = useCallback<SubmitHandler<Evaluation>>(
    async data => {
      setLoading(true);
      if (submit) {
        const resp = await submit(data, '7 - Aspectos Técnicos', true);
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [functionCallback, submit],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={technicalAspectsValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box disabled={!!ctx.data.name}>
              <Label>
                O projeto levou em consideração medidas apropriadas de segurança administrativa?
                Quais?
              </Label>
              <MessageInfo items={MessageInfoItems} marginTop="14px" marginBottom="20px" />
              <TextAreaInput
                placeholder="Digite aqui se o projeto levou em consideração medidas apropriadas de segurança administrativa"
                name="appropriateInformationSecurityMeasures"
                // {...commonProps}
              />
            </Box>
            <Box disabled={!!ctx.data.name} mt="36px" mb="20px">
              <TextAreaInput
                mt="8px"
                label="O projeto levou em consideração medidas apropriadas de segurança da informação? Quais?"
                placeholder="Digite aqui se o projeto levou em consideração medidas apropriadas de segurança da informação"
                name="appropriateInformationSecurityMeasuresInformation"
                // {...commonProps}
              />
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Concluir
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Concluir
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box disabled={!!ctx.data.name}>
              <Label>
                O projeto levou em consideração medidas apropriadas de segurança administrativa?
                Quais?
              </Label>
              <MessageInfo items={MessageInfoItems} marginTop="14px" marginBottom="20px" />
              <TextAreaInput
                placeholder="Digite aqui se o projeto levou em consideração medidas apropriadas de segurança administrativa"
                name="appropriateInformationSecurityMeasures"
                isDisabled={completed}
              />
            </Box>
            <Box disabled={!!ctx.data.name} mt="36px" mb="20px">
              <TextAreaInput
                mt="8px"
                label="O projeto levou em consideração medidas apropriadas de segurança da informação? Quais?"
                placeholder="Digite aqui se o projeto levou em consideração medidas apropriadas de segurança da informação"
                name="appropriateInformationSecurityMeasuresInformation"
                isDisabled={completed}
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Concluir
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const TechnicalAspects = memo(TechnicalAspectsComponent);
